import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const ChainSolutionPage = () => {
  useEffect(() => {
    document.title = 'Zincir İşletme / Market Dijital Çözümü | Çoklu Şube Yönetimi, POS, Online Sipariş';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Zincir işletmeler için çoklu şube yönetimi, merkezi menü ve fiyat, online sipariş ve kurye takibi. POS ve raporlama ile tek panelden tüm şubeler.');

    // Canonical
    const canonicalHref = `${siteUrl}/solutions/chain`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Zincir İşletme Dijital Çözümü',
      serviceType: 'Çoklu Şube Otomasyon Sistemi',
      areaServed: 'TR'
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Zincir İşletmeler için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">Merkezi menü–fiyat yönetimi ve çoklu şube raporlamasıyla operasyonel verimliliği artırın. Online sipariş ve kurye ile uçtan uca teslimat kontrolü.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>Merkezi menü–fiyat ve kampanya yönetimi</li>
                <li>Şube bazlı yetki ve raporlama</li>
                <li>Kurye ve teslimat ağı yönetimi</li>
                <li>AI destekli stok–talep planlama</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Zincirler için Modüller</h2>
            <p>Merkezi menü–fiyat yönetimi, şube yetkileri ve raporlama zincir operasyonların kalbidir. Aşağıdaki modüllerle tek panelden yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Merkezi Menü ve POS</h3>
            <p><a className="text-primary underline" href="/pos-system">POS</a> ile şubeler arası tutarlılık ve hızlı kasa deneyimi sağlayın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş ve Kurye</h3>
            <p><a className="text-primary underline" href="/online-order">Online Sipariş</a> ve <a className="text-primary underline" href="/courier-system">Kurye</a> ile teslimat ağınızı verimli yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">AI ile Talep ve Stok Planlama</h3>
            <p><a className="text-primary underline" href="/ai-system">AI</a> ile talep tahmini, kampanya etki analizi ve şube performans kıyaslaması yapın.</p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Şube bazlı yetki yönetimi var mı?</summary>
                <p className="mt-2">Evet. Kullanıcı rolleri ve şube yetkilendirmeleri mevcuttur.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Merkezi fiyat ve kampanya yönetimi nasıl yapılır?</summary>
                <p className="mt-2">Panel üzerinden merkezi tanımlarla tüm şubelerde anlık güncellemeler yapılabilir.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default ChainSolutionPage;


